
<template>
  <v-container>
    <v-row v-if="data.list" align="center">
      <v-col cols="12" md="10" class="mx-auto">
        <v-row>
          <v-col cols="12" v-for="type in categories" :key="type.id">
            <v-btn
              variant="text"
              class="rounded-0 btn-primelinks mb-4"
              :href="type.full_slug"
              :title="type.title"
            >
              <h2 class="text-h5 text-md-h4 mb-2">{{ type.title }}</h2>
            </v-btn>
            <v-divider></v-divider>
            <v-row no-gutters>
              <v-col
                cols="6"
                class="mx-auto"
                v-for="page in type.list"
                :key="page.full_slug"
              >
                <v-card class="rounded-0" :title="page.title" :to="page.route" :href="page.full_slug">
                  <v-img
                    :lazy-src="page.thumbnail.sizes.thumbnail"
                    :src="page.thumbnail.sizes.full"
                    :aspect-ratio="21/9"
                    :title="page.title"
                    :alt="page.title"
                    gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                    cover
                  >
                    <v-container class="fill-height">
                      <v-row
                        no-gutters
                        class="fill-height text-start"
                        align="end"
                      >
                        <v-col cols="12">
                          
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-img>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
export default {
  props: {
    data: {
      required: true,
      type: Object,
    },
  },
  data: () => ({
    categories: null,
  }),
  mounted() {
    this.categories = this.groupBy(this.data.list, "type_title");
  },
  methods: {
    groupBy(array, key) {
      var newrray = {};

      array.forEach((element) => {
        if (!newrray[element[key]]) {
          // crea categoria
          newrray[element[key]] = {
            id: element.type_id,
            title: element.type_title,
            full_slug: element.type_slug,
            route: element.type_route,
            list: [],
          };
        }
        // aggiungi elemento
        newrray[element[key]].list.push(element);
      });

      return newrray;
    },
  },
};
</script>

<style scoped>
.linea {
  position: relative;
  top: 1.62rem;
}
</style>